(function() { window.GUID_2a1e1f33_9661_4648_add6_f682b5b85dbb = { getGuid: function() { return "2a1e1f33-9661-4648-add6-f682b5b85dbb"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EntityType;
        (function (EntityType) {
            EntityType[EntityType["Player"] = 0] = "Player";
            EntityType[EntityType["Team"] = 1] = "Team";
        })(EntityType = Enumeration.EntityType || (Enumeration.EntityType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EntityType.pre.js.map
